// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-thumbnails {
    width: 100%;
    background: transparent;
    padding: 0;
    height: auto;
    display: flex;
    flex-direction: column;
}

.page-thumbnails h3 {
    font-size: 0.85em;
    text-transform: uppercase;
    color: #718096;
    margin-bottom: 15px;
    letter-spacing: 0.05em;
}

.thumbnails-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.thumbnail-item {
    cursor: pointer;
    border: 2px solid transparent;
    border-radius: 12px;
    padding: 8px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: #ffffff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    position: relative;
}

.thumbnail-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.thumbnail-item.active {
    border-color: #4299e1;
    background: #ebf8ff;
    box-shadow: 0 8px 20px rgba(66, 153, 225, 0.15);
}

.thumbnail-preview {
    aspect-ratio: 1.414 / 1;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    color: #cbd5e0;
    font-size: 1.8em;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);
    cursor: pointer;
}

.thumbnail-item.active .thumbnail-preview {
    border-color: #bee3f8;
}

.thumbnail-label {
    padding: 8px;
    font-size: 0.9em;
    font-weight: 600;
    text-align: center;
    background: white;
    color: #2d3748;
    border-top: 1px solid #edf2f7;
}

.btn-delete-page {
    position: absolute;
    top: 4px;
    right: 4px;
    background: #fc8181;
    border: none;
    border-radius: 6px;
    padding: 4px 8px;
    cursor: pointer;
    font-size: 0.9em;
    transition: all 0.2s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    opacity: 0;
    z-index: 10;
}

.thumbnail-item:hover .btn-delete-page {
    opacity: 1;
}

.btn-delete-page:hover {
    background: #f56565;
    transform: scale(1.1);
}`, "",{"version":3,"sources":["webpack://./src/components/MaqueteEditor/PageThumbnails.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,uBAAuB;IACvB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,iDAAiD;IACjD,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,+CAA+C;AACnD;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,+CAA+C;IAC/C,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,wCAAwC;IACxC,UAAU;IACV,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB","sourcesContent":[".page-thumbnails {\r\n    width: 100%;\r\n    background: transparent;\r\n    padding: 0;\r\n    height: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.page-thumbnails h3 {\r\n    font-size: 0.85em;\r\n    text-transform: uppercase;\r\n    color: #718096;\r\n    margin-bottom: 15px;\r\n    letter-spacing: 0.05em;\r\n}\r\n\r\n.thumbnails-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n}\r\n\r\n.thumbnail-item {\r\n    cursor: pointer;\r\n    border: 2px solid transparent;\r\n    border-radius: 12px;\r\n    padding: 8px;\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n    background: #ffffff;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\r\n    position: relative;\r\n}\r\n\r\n.thumbnail-item:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.thumbnail-item.active {\r\n    border-color: #4299e1;\r\n    background: #ebf8ff;\r\n    box-shadow: 0 8px 20px rgba(66, 153, 225, 0.15);\r\n}\r\n\r\n.thumbnail-preview {\r\n    aspect-ratio: 1.414 / 1;\r\n    background: #f8fafc;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 8px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-weight: 700;\r\n    color: #cbd5e0;\r\n    font-size: 1.8em;\r\n    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);\r\n    cursor: pointer;\r\n}\r\n\r\n.thumbnail-item.active .thumbnail-preview {\r\n    border-color: #bee3f8;\r\n}\r\n\r\n.thumbnail-label {\r\n    padding: 8px;\r\n    font-size: 0.9em;\r\n    font-weight: 600;\r\n    text-align: center;\r\n    background: white;\r\n    color: #2d3748;\r\n    border-top: 1px solid #edf2f7;\r\n}\r\n\r\n.btn-delete-page {\r\n    position: absolute;\r\n    top: 4px;\r\n    right: 4px;\r\n    background: #fc8181;\r\n    border: none;\r\n    border-radius: 6px;\r\n    padding: 4px 8px;\r\n    cursor: pointer;\r\n    font-size: 0.9em;\r\n    transition: all 0.2s;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    opacity: 0;\r\n    z-index: 10;\r\n}\r\n\r\n.thumbnail-item:hover .btn-delete-page {\r\n    opacity: 1;\r\n}\r\n\r\n.btn-delete-page:hover {\r\n    background: #f56565;\r\n    transform: scale(1.1);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
